export function useIsChristmas(): boolean {
  return new Date().getMonth() === 11; // December is month 11 (0-indexed)
}
